import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import AuthShell from "./AuthShell";
import api, { formatApiErrorDetail } from "@/lib/api";
import { AUTH } from "@/constants/testIds";

export default function Reset() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. Please sign in.");
      navigate("/login");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell
      title="Choose a new password"
      subtitle="Set a strong password of at least 8 characters."
      footer={<Link to="/login" className="text-primary hover:underline">← Back to sign in</Link>}
    >
      <form onSubmit={onSubmit} className="space-y-4">
        <input type="hidden" value={token} readOnly />
        <div className="space-y-1.5">
          <label className="text-xs font-medium text-muted-foreground">New password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            minLength={8}
            required
            data-testid={AUTH.passwordInput}
            className="w-full rounded-xl bg-muted/40 border border-border px-4 py-3 text-sm outline-none focus:border-primary focus:ring-2 focus:ring-primary/30"
          />
        </div>
        {error && <div data-testid={AUTH.error} className="text-sm text-red-500">{error}</div>}
        <button type="submit" disabled={busy || !token} data-testid={AUTH.submit} className="btn-primary w-full py-3 text-sm">
          {busy ? "Updating…" : "Update password"}
        </button>
      </form>
    </AuthShell>
  );
}
